import { Moment } from 'moment';
import React from 'react';
import GridFilterItem from '../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../Base/Enums/GridFilterItemType.enum';
import GridFilter from '../../Base/Components/GridFilter/GridFilter';
import moment from 'moment';
import { GRID_FILTER_KEYS } from '../../Base/Components/GridFilter/gridFilterKeys';
import { getMomentDate } from '../../../Utils/dates.util';

const DEFAULT_VALUES = {
	from: moment().subtract(1, 'month'),
	to: moment(),
};

export interface WorkplaceDoctorStatisticsFilterValues {
	from?: Moment;
	to?: Moment;
}

interface Props {
	onFilter: (filter: WorkplaceDoctorStatisticsFilterValues) => void;
	onReady?: () => void;
}

const WorkplaceDoctorStatisticsFilter: React.FC<Props> = ({
	onFilter,
	onReady,
}) => {
	const handleOnFilterChange = (
		values: WorkplaceDoctorStatisticsFilterValues,
	) => {
		onFilter({
			from: values?.from ? getMomentDate(values.from) : undefined,
			to: values?.to ? getMomentDate(values.to) : undefined,
		});
	};

	return (
		<GridFilter
			onChange={handleOnFilterChange}
			onReady={onReady}
			defaultValues={DEFAULT_VALUES}
			storageKey={GRID_FILTER_KEYS.WORKPLACE_DOCTOR_STATISTICS_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				customKey='from'
				contentWidth={170}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_TO}
				customKey='to'
				contentWidth={170}
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default WorkplaceDoctorStatisticsFilter;
